import { PatchingGrammar } from "./PatchingGrammar";
import { PatchingTopics } from "./PatchingTopics";
import { Sample1110000 } from "./Sample1110000";
import { Sample1125000 } from "./Sample1125000";
import { Sample2020000 } from "./Sample2020000";
import { Sample2028000 } from "./Sample2028000";
import { Sample2030000 } from "./Sample2030000";
import { Sample2032000 } from "./Sample2032000";

function Analysis() {
  return (
    <section id="Analysis">
      <h2>Analysis</h2>
      <h3 id="GrammaticalPatterns">Grammar</h3>
      <p>
        Upstream features in early layers influence downstream features and respond to simple
        patterns. Through self-attention and the feedforward network, downstream features build on
        upstream ones to create activations that respond to grammatical patterns representing more
        complex concepts.
      </p>
      <Sample2020000 />
      <Sample2030000 />
      <h3 id="Topics">Topics</h3>
      <p>
        Features representing specific topics are constructed alongside those responding to
        grammatical patterns. These features use self-attention to build upon earlier features
        representing words in specific contexts. Features representing topics fire broadly across a
        range of words within a sentence and emerge within the final few layers of a circuit.
      </p>
      <Sample1125000 />
      <Sample2032000 />
      <h3 id="Predictions">Predictions</h3>
      <p>
        Features representing the subject of a sentence are used in conjunction with features
        responding to grammatical patterns to produce predictions. Grammatical relationships
        constrain the parts of speech that the next token may belong to. Topics are used to
        constrain the semantic meaning of what comes next.
      </p>
      <Sample1110000 />
      <Sample2028000 />
      <h3 id="Patching">Patching</h3>
      <p>
        Feature activations can be patched to predictably steer the output of an LLM. Upstream
        features influencing the processing of grammatical patterns can be patched to alter the next
        token’s part-of-speech. Upstream features can also be patched to modify the topic of a
        sentence without altering a sentence’s grammatical structure.
      </p>
      <PatchingGrammar />
      <PatchingTopics />
    </section>
  );
}

export { Analysis };
